// third-party
import { Category2, Map } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS — YORA ||============================== //

const yoraMenu: NavItemType = {
  id: 'yora',
  title: 'Yora',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: Category2,
      breadcrumbs: false
    },
    {
      id: 'process-mapping',
      title: 'menu.processMapping',
      type: 'item',
      url: '/process-mapping',
      icon: Map
    }
  ]
};

export default yoraMenu;
